import React, { useEffect, useState } from "react"
import TMHBanner from "../../components/TMHBannerv2/TMHBanner"
import TMHFooter from "../../components/TMHFooterv2/TMHFooter"
import "./CongratulationsPage.scss"
import LogoImg from "./logo.png"
import { useTitle } from "react-use"
import ReactGA from "react-ga4"
import { useNavigate } from "react-router-dom";
import validator from 'validator';
import TMHLoader from "../../components/TMHLoader/TMHLoader";
import config from "../../config.json"
import useAuth from "../../core/Authentication/useAuth"

const CongratulationsPage = () => {
    useTitle("Congratulations - Free Movie Quiz")
    useEffect(() => {
        ReactGA.send("pageview")
    })

    const [isLoading, setIsLoading] = useState(false)
    const [emailAddress, setEmailAddress] = useState("")
    const [password, setPassword] = useState("")
    const [errorText, setErrorText] = useState("")
    const navigate = useNavigate()
    const auth = useAuth()

    async function handleSubmit(event) {
        event.preventDefault()

        if (!validator.isEmail(emailAddress)) {
            setErrorText("Invalid email address!")
            return
        }

        if (password === "") {
            setErrorText("Password cannot be empty!")
            return
        }

        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");
        myHeaders.append("Cache-Control", "no-cache");

        var requestOptions = {
            method: 'POST',
            headers: myHeaders,
            body: JSON.stringify({
                "username": emailAddress,
                "password": password,
                "signup_method": "FreeMovieQuiz"
            }),
        };

        setIsLoading(true)

        setErrorText("")
        setIsLoading(true)
        fetch(config.baseUrl + "register", requestOptions)
            .then((response) => {
            return new Promise((resolve) => response.json()
              .then((json) => resolve({
                status: response.status,
                ok: response.ok,
                json,
              })))
            }).then(
                (result) => {
                    let json = result.json
                    if (result.ok) {
                        auth.login({
                            pin: json.pin,
                            username: json.username,
                            user_id: json.user_id,
                            token: json.token
                        })
                        navigate("/congratulations");
                    }
                    else {
                        setErrorText(json.message)
                        setIsLoading(false)
                    }
                },
                (error) => {
                    console.error(error)
                    setErrorText(error.toString())
                    setIsLoading(false)
                }
            )
    }

    return (
        <>
            <TMHBanner />
            <div className="congratulations-page">
                <div className="background" />
                <div className="content">
                    <a href="https://themoviehouse.tv/" target="_blank" rel="noreferrer">
                        <img className="logo" src={LogoImg} alt="Movie House logo" />
                    </a>
                    <div className="line" />
                    <div className="title">Congratulations <br /> your answer is correct!</div>
                    <div className="description-wrapper">
                        <div className="description">Claim your Free New Release Movie by entering in your email and password to sign up for The Movie House.</div>
                        <div className="description">Ensure your email is correct as details to watch your movie will be sent to you directly.</div>
                    </div>
                    <form className="sign-up-form" onSubmit={handleSubmit} method="POST">
                        <input 
                            type="text"
                            placeholder="Email"
                            value={emailAddress}
                            onChange={({ target }) => setEmailAddress(target.value)} />
                        <input 
                            type="password"
                            placeholder="Password"
                            autoComplete="off"
                            value={password}
                            onChange={({ target }) => setPassword(target.value)} />
                        <button type="submit" className="submit-button">Continue</button>
                        <div className="error-text">
                            {errorText}
                        </div>
                    </form>
                </div>
            </div>
            {isLoading && <TMHLoader />}
            <TMHFooter />
        </>
    )
}

export default CongratulationsPage